<template lang="pug">
div
  .d-flex.align-center.mb-4
    v-spacer
    v-btn(color="primary" depressed @click="$refs.form.open()")
      v-icon.mr-1 mdi-plus
      | Nuevo producto o servicio

  .text-center.py-8(v-if="loading")
    v-progress-circular(indeterminate color="primary")

  v-simple-table(v-else-if="rows.length")
    template(v-slot:default)
      thead
        tr
          th Producto o servicio
          th Línea de negocio
          th.text-right Ticket promedio
          th.text-right Costo variable
          th.text-right Margen
          th.text-right Capacidad al mes
          th(style="width:56px")
      tbody
        tr(v-for="p in rows" :key="p.id")
          td {{ p.name }}
          td
            v-chip(x-small outlined) {{ p.lineName }}
          td.text-right {{ p.market_price | currency }}
          td.text-right {{ p.unit_cost | currency }}
          td.text-right {{ marginText(p) }}
          td.text-right {{ capacityText(p) }}
          td
            v-menu(offset-y left)
              template(v-slot:activator="{ on, attrs }")
                v-btn(icon small v-bind="attrs" v-on="on")
                  v-icon(small) mdi-dots-vertical
              v-list(dense)
                v-list-item(@click="$refs.form.open({ item: p })")
                  v-list-item-title Editar
                v-list-item(@click="removeProduct(p)")
                  v-list-item-title Eliminar

  .text-center.grey--text.py-8(v-else)
    | Aún no tienes productos o servicios. Crea el primero con el botón de arriba.

  SimpleProductFormModal(ref="form" @save="reload")
  CustomConfirmDialog(ref="confirm")
</template>

<script>
import { mapActions } from 'vuex'
import SimpleProductFormModal from '@/components/products/SimpleProductFormModal.vue'
import CustomConfirmDialog from '@/components/common/dialogs/CustomConfirmDialog.vue'

export default {
  name: 'SimpleProductsList',
  components: { SimpleProductFormModal, CustomConfirmDialog },
  data() {
    return { loading: false, rows: [] }
  },
  methods: {
    ...mapActions('product', ['listLineOfBusiness', 'listProducts', 'deleteProduct', 'checkHasProducts']),
    // 0 en BD = sin tope declarado: el Mix Óptimo no restringe ese producto.
    capacityText(p) {
      const cap = Number(p.monthly_production_capacity)
      if (!cap || isNaN(cap) || cap <= 0) return 'Sin tope'
      return cap.toLocaleString('es-CL')
    },
    marginText(p) {
      const price = Number(p.market_price)
      const cost = Number(p.unit_cost)
      if (!price) return '—'
      const amount = price - cost
      return `$${amount.toLocaleString('es-CL')} (${Math.round((amount / price) * 100)}%)`
    },
    async reload() {
      this.loading = true
      const lres = await this.listLineOfBusiness()
      const ld = lres && lres.data
      const lines = Array.isArray(ld) ? ld : (ld && ld.results) || []
      const rows = []
      const seen = new Set()
      // productos por línea (así conocemos el nombre de la línea de cada uno)
      await Promise.all(lines.map(async line => {
        const r = await this.listProducts({ params: { base_product__line_of_business: line.id, page_size: 500 } })
        const items = (r && r.data && r.data.results) || []
        items.forEach(p => { seen.add(p.id); rows.push({ ...p, lineName: line.name }) })
      }))
      // productos sin línea (si una línea fue eliminada)
      const all = await this.listProducts({ params: { page_size: 500 } })
      const allItems = (all && all.data && all.data.results) || []
      allItems.forEach(p => { if (!seen.has(p.id)) rows.push({ ...p, lineName: 'Sin línea' }) })
      rows.sort((a, b) => (a.lineName || '').localeCompare(b.lineName || '') || (a.name || '').localeCompare(b.name || ''))
      this.rows = rows
      this.loading = false
      this.checkHasProducts()
    },
    async removeProduct(p) {
      const ok = await this.$refs.confirm.open('Eliminar', `¿Eliminar "${p.name}"?`, { okTitle: 'Eliminar', icon: 'mdi-delete' })
      if (!ok) return
      const res = await this.deleteProduct(p.id)
      if (res && !res.error) {
        this.$toast.success('Eliminado.')
        await this.reload()
      } else {
        this.$toast.error('No se pudo eliminar.')
      }
    },
  },
  created() {
    this.reload()
  },
}
</script>
